/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */

$(document).ready(function() {
	/* header logo */
	$(".t-anvers-events-template .header__logo-image, .t-anvers-accommodation-template .header__logo-image, .t-anvers-weddings-template .header__logo-image, .t-anvers-our-wines-template .header__logo-image,.t-list-collections .header__logo-image").attr('src', 'https://cdn.shopify.com/s/files/1/0630/4183/1163/files/ANVERS_BLACK.png?v=1652670062');
	
  /* img with text heights */
  var IWTSections = $(".shopify-section--anvers-image-with-text:not(.video-with-text)");
  
  function resizeIWT(IWTArray) {
	let imgWithTextSections = IWTArray;
    for (i = 0; i < imgWithTextSections.length; i++) {
      let thisSection = $(imgWithTextSections[i]);
      let thisContentHeight = thisSection.find(".image-with-text__content-wrapper").height();
      let thisImg = thisSection.find(".image-with-text__image");
      thisImg.css("min-height", thisContentHeight + "px");
    }
  }
  
  if (IWTSections) {
	resizeIWT(IWTSections);
    $(window).on('resize', _.debounce(function() {
      let win = $(this);
      if (win.innerWidth() > 1000) {
       resizeIWT(IWTSections);
      }
    }, 250));
  } 
  
  if ($("body").hasClass("t-index")) {
    var moveCount = 0;
    var resetCount = 0;
    
    function moveImgBlocks() {
      	if (moveCount < 1) {
          console.log("move");
          let imgBlockCols = $(".img-block-col");
          let headingBlockCols = $(".heading-block-col");
          for (i = 0; i < imgBlockCols.length; i++) {
            headingBlockCols[i].before(imgBlockCols[i]);        
          }
          moveCount = 1;
          resetCount = 0;
		}
      }
    
    function resetImgBlocks() {
      if ((moveCount > 0) && (resetCount < 1)) {
        console.log("reset");
        let imgBlockRow = $(".img-block-row:not(.heading-block-row");
        let imgBlockCols = $(".img-block-col");
        console.log(imgBlockRow);
        imgBlockRow.append(imgBlockCols);
        resetCount = 1;
        moveCount = 0;
      }
    }
    
      if (window.innerWidth <= 700) {
	  	moveImgBlocks();
	  }
      
      $(window).on('resize', _.debounce(function() {
        let win = $(this);
        if (win.innerWidth() <= 700) {
          moveImgBlocks();
	  	}
        else {
			resetImgBlocks();
		}
      }, 250));
	}
  	
  
  	var viewport = $('.vimeo'),
      	frame = viewport.find('iframe'),
        frameRatio = 16 / 9;
  
	function resizeVimeoBGVids(viewport, frame, frameRatio) {
      
      var contentHeight = $(".vimeo-text").outerHeight();
      viewport.css("min-height", contentHeight + "px");

      var width = viewport.outerWidth(),
          height = viewport.outerHeight(),
          ratio = width / height,
          targetWidth = width,
          targetHeight = height;

      if (ratio > frameRatio) {
        // viewport is wider than video, so we correct the height
        targetHeight = width / frameRatio;
      }
      else {
        // viewport is taller than video, so we correct the width
        targetWidth = width * frameRatio;
      }

      frame.css({width: targetWidth, height: targetHeight})
	}
  
    if (viewport) {
      if ($(window).innerWidth() >= 1000) {
		resizeVimeoBGVids(viewport, frame, frameRatio);
	  }
      $(window).on('resize', _.debounce(function() {
        let win = $(this);
        if (win.innerWidth() > 1000) {
         resizeVimeoBGVids(viewport, frame, frameRatio);
        }
      }, 250));
    } 
  
  
});

// open certain menu links in new tab
var links = document.querySelectorAll(".mobile-nav__link, .main-link");
for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
  if (links[i].hostname !== window.location.hostname) {
    links[i].target = '_blank';
    links[i].rel = 'noreferrer noopener';
  }
}

// custom booking drawer
const bookingLinks = document.querySelectorAll('.booking-link');
const bookingsDrawer = document.getElementById('bookings-drawer');
const bookingsDrawerOverlay = bookingsDrawer.querySelector('.drawer__overlay');
const bookingsDrawerClose = bookingsDrawer.querySelector('.drawer__close-button');
const html = document.html; 
bookingLinks.forEach((link) => {
  link.addEventListener("click", function() {
    bookingsDrawer.setAttribute("open", "");
    document.documentElement.classList.add("lock-all");
  })
});
bookingsDrawerOverlay.addEventListener("click", function() {
    bookingsDrawer.removeAttribute("open");
    document.documentElement.classList.remove("lock-all");
});
bookingsDrawerClose.addEventListener("click", function() {
    bookingsDrawer.removeAttribute("open");
    document.documentElement.classList.remove("lock-all");
});

const menuDrawer = document.getElementById("mobile-menu-drawer");
// The booking link inside the menu drawer
const menuBookingLink = document.getElementById("menu-booking-link");

menuBookingLink.addEventListener("click", function() {
  console.log(menuDrawer);
  if (menuDrawer.hasAttribute("open")) {
     menuDrawer.removeAttribute("open");
  }
})
